/* RESPONSIBLE TEAM: team-inbox */
import Route from '@ember/routing/route';

export default class WelcomeHelpdeskRoute extends Route {}
